import React from 'react';

import Layout from 'layouts/Layout';
import Commercial from './Commercial';

const CommercialLayout = ({ match }) => <Layout component={Commercial} match={match} />;

export default CommercialLayout;
